























import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";
import OrderDetail from "@/views/bill/detail.vue";

@Component({
  components: {
    OrderDetail
  }
})
export default class extends Mixins(MyList) {
  @Prop() userId!: number;

  billId!: number;

  orderDetailModalVisible = false;

  dispatchType = "users/orderbill";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "订场时间", dataIndex: "created_time" },
    { title: "场馆", dataIndex: "stadium_name" },
    { title: "金额", scopedSlots: { customRender: "cost" } },
    { title: "状态", scopedSlots: { customRender: "bill_status" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData(
      {
        user_id: this.userId,
        page: 1
      },
      false
    );
  }

  showOrderDetailModal(id: number) {
    this.billId = id;
    this.orderDetailModalVisible = true;
  }

  hideOrderDetailModal() {
    this.orderDetailModalVisible = false;
  }
}
